import React from 'react';
import classNames from 'classnames';

type ParagraphProps = {
    className?: string;
    children?: React.ReactNode;
};

export const Paragraph: React.FC<ParagraphProps> = ({
    children,
    className,
    ...rest
}) => (
    <p className={classNames('spacing-bottom--xsmall', className)} {...rest}>
        {children}
    </p>
);
